import {PumpsConstraintsDto} from '../../options/unloadingMethods.types'

import {PumpForm} from './types'

/**
 * Creates default pump settings from pump configuration
 *
 * @param pumpConfiguration - Pump constraints configuration
 * @returns Default pump settings or undefined if pumps are disabled
 */
export const getDefaultPumpSettings = (
  pumpConfiguration: PumpsConstraintsDto
): PumpForm['pumpSettings'] | undefined => {
  if (!pumpConfiguration.isEnabled) {
    return undefined
  }

  return {
    canLargerPumpFit: pumpConfiguration.defaultSettings.canLargerPumpFit,
    isPossibleToCleanPumpOnSite: pumpConfiguration.defaultSettings.isPossibleToCleanPumpOnSite,
    discharge:
      pumpConfiguration.defaultSettings.discharge === 'hose'
        ? {
            method: 'hose',
            hoseLength: pumpConfiguration.hoseLength.default ?? pumpConfiguration.hoseLength.min
          }
        : {method: pumpConfiguration.defaultSettings.discharge}
  } as PumpForm['pumpSettings']
}

/**
 * Creates default pump form with default pump number and settings
 *
 * @param pumpConfiguration - Pump constraints configuration
 * @returns Complete PumpForm or undefined if pumps are disabled
 */
export const getDefaultPumpForm = (pumpConfiguration: PumpsConstraintsDto): PumpForm | undefined => {
  if (!pumpConfiguration.isEnabled) {
    return undefined
  }

  const defaultPumpSettings = getDefaultPumpSettings(pumpConfiguration)
  if (!defaultPumpSettings) {
    return undefined
  }

  return {
    pumpNumber: pumpConfiguration.pumpTypes.default,
    pumpSettings: defaultPumpSettings
  }
}
